/**
 * better-auth browser client.
 *
 * Only identity lives here. Everything about what the person may do comes from
 * `GET /api/v1/me`, because the laboratory's roles and departments are owned by
 * the API, not by the auth service.
 */

import { createAuthClient } from "better-auth/react";
import { adminClient, organizationClient, twoFactorClient } from "better-auth/client/plugins";

import { AUTH_BASE_URL, clearToken } from "./api";

export const authClient = createAuthClient({
  // Must be absolute: the client parses this with `new URL()` when the module
  // loads, so a relative path throws before anything renders.
  baseURL: AUTH_BASE_URL,
  plugins: [twoFactorClient(), adminClient(), organizationClient()],
  fetchOptions: {
    credentials: "include",
  },
});

export const { useSession, signIn, signUp, getSession } = authClient;

export async function signOut(): Promise<void> {
  // Drop the cached bearer token first: a stale token outliving the session
  // would otherwise keep authorising API calls until it expired.
  clearToken();
  await authClient.signOut();
  window.location.href = "/sign-in";
}
